const messages = {
  title: "Mein Postfach",
  desc: "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihr Postfach einsehen.",
  newMessages: "Neue Nachrichten in deinem Postfach",
  link: "Nachrichten anzeigen",
  showMessages: "Nachrichten anzeigen",
  message: {
    sender: "Absender",
    thread: "Betreff",
    date: "Datum",
  },
  sender: {
    system: "BRIDGESTONE PLUS",
    admin: "Admin",
  },
  back: "Zurück",
  time: {
    secondsAgo: "{time} Sekunden zuvor",
    minutesAgo: "{time} Minuten zuvor",
    hoursAgo: "{time} Stunden zuvor",
    daysAgo: "{time} Tage zuvor",
  },
};

export default {
  messages,
};
